module.exports = __webpack_public_path__ + "static/media/calendar.0bad9d98.svg";